import { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import { Lock, Loader2, ArrowLeft } from 'lucide-react';

/**
 * Portail admin : modale bloquante demandant le 2e mot de passe d'accès à l'espace
 * de gestion (vérifié côté serveur contre secure/app.php → ADMIN_GATE_HASH).
 * Affichée par AdminLayout quand une requête admin renvoie 403 reason 'gate_required'.
 * En cas de succès, le serveur renvoie un JWT portant le claim admin_gate ; on le
 * stocke et on recharge (le claim est ainsi mémorisé pour cet appareil).
 */
export default function AdminGate() {
    const [pwd, setPwd] = useState('');
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);

    const submit = async (e) => {
        e.preventDefault();
        if (!pwd || busy) return;
        setBusy(true);
        setError(null);
        try {
            const { data } = await api.post('/admin/gate.php', { password: pwd });
            const newToken = data.data?.token;
            if (newToken) {
                localStorage.setItem('monquiz_token', newToken);
                window.location.reload();
                return;
            }
            setError('Réponse inattendue du serveur.');
            setBusy(false);
        } catch (err) {
            setError(err.response?.data?.message || 'Mot de passe incorrect.');
            setBusy(false);
        }
    };

    return (
        <div style={{ position: 'fixed', inset: 0, zIndex: 10000, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
            <div style={{ background: 'var(--card-bg)', border: '1px solid var(--border)', borderRadius: 12, maxWidth: 380, width: '100%', padding: 24, boxShadow: '0 20px 60px rgba(0,0,0,0.4)' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                    <Lock size={18} style={{ color: 'var(--primary, #7c3aed)' }} />
                    <h2 style={{ margin: 0, fontSize: '1.1em' }}>Accès gestion</h2>
                </div>
                <p style={{ margin: '0 0 16px', fontSize: '0.9em', color: 'var(--text-muted)' }}>
                    Saisis le mot de passe d&apos;accès à l&apos;espace de gestion pour déverrouiller cet appareil.
                </p>
                <form onSubmit={submit}>
                    <input
                        type="password"
                        autoFocus
                        autoComplete="off"
                        value={pwd}
                        onChange={(e) => setPwd(e.target.value)}
                        placeholder="Mot de passe d'accès"
                        style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: '1px solid var(--border)', background: 'var(--input-bg, transparent)', color: 'inherit', marginBottom: 12, boxSizing: 'border-box' }}
                    />
                    {error && <p style={{ margin: '0 0 12px', fontSize: '0.82em', color: '#ef4444' }}>{error}</p>}
                    <button type="submit" className="btn btn-primary" disabled={!pwd || busy} style={{ width: '100%', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
                        {busy ? <Loader2 size={16} className="spin" /> : <Lock size={16} />} Déverrouiller
                    </button>
                </form>
                <Link to="/compte" style={{ display: 'inline-flex', alignItems: 'center', gap: 6, marginTop: 14, fontSize: '0.82em', color: 'var(--text-muted)' }}>
                    <ArrowLeft size={14} /> Retour à mon compte
                </Link>
            </div>
        </div>
    );
}
